import { render, staticRenderFns } from "./kdProblemIndex.vue?vue&type=template&id=80c2c888"
import script from "./kdProblemIndex.vue?vue&type=script&lang=js"
export * from "./kdProblemIndex.vue?vue&type=script&lang=js"
import style0 from "../problemDetails/problemDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports